export const RUN_USER_LOGIN 	 							 =        		'RUN_USER_LOGIN'
export const RUN_QUICKO_LOGIN_WITH_OTP 	 				     =        		'RUN_QUICKO_LOGIN_WITH_OTP'
export const RUN_QUICKO_LOGIN_WITH_OTP_VERIFY 	 		     =        		'RUN_QUICKO_LOGIN_WITH_OTP_VERIFY'
export const RUN_USER_VPA 	 							 	 =        		'RUN_USER_VPA'
export const RUN_CHECK_BANK_LIST_AGGREGATOR 	 			 =        		'RUN_CHECK_BANK_LIST_AGGREGATOR'
export const RUN_ADMIN_LOGIN 	 							 =        		'RUN_ADMIN_LOGIN'
export const RUN_STATE_LOAD 	 							 = 		  		'RUN_STATE_LOAD'
export const RUN_USER_LOGOUT 	 							 = 		  		'RUN_USER_LOGOUT'
export const RUN_WEB_ENGAGE_USER                             =              'RUN_WEB_ENGAGE_USER'

export const SET_API_DISCLAIMER                              =              'SET_API_DISCLAIMER'

export const RUN_ADD_STEP_AFTER_UPLOAD_PROFILE_IMAGE 	 	= 		  		'RUN_ADD_STEP_AFTER_UPLOAD_PROFILE_IMAGE'

export const RUN_ADMIN_ACCESS_USER_OTP		 			     = 		 		'RUN_ADMIN_ACCESS_USER_OTP'

export const RUN_USER_LOGIN_WITH_OTP		 			     = 		 		'RUN_USER_LOGIN_WITH_OTP'

export const RUN_USER_VERIFY_OTP		 			     	= 		 		'RUN_USER_VERIFY_OTP'

export const RUN_CREATE_LEAD 	 							 = 		  		'RUN_CREATE_LEAD'
export const RUN_VERIFY_LEAD_OTP 							 = 		  		'RUN_VERIFY_LEAD_OTP'
export const RUN_VERIFY_DOB		 							 = 		  		'RUN_VERIFY_DOB'
export const RUN_PAN_VERIFY		 							 = 		 		'RUN_PAN_VERIFY'
export const RUN_SAVE_USERNAME_COMIG_FROM_PAN_API		 	 = 		 		'RUN_SAVE_USERNAME_COMIG_FROM_PAN_API'

export const RUN_REGISTER_INITIAL_STEP1		 	  			 = 		  		'RUN_REGISTER_INITIAL_STEP1'
export const RUN_REGISTER_INITIAL_STEP2		 	 			 = 		  		'RUN_REGISTER_INITIAL_STEP2'
export const RUN_ADD_REGISTER_DATA_STEP0		 			 = 		  		'RUN_ADD_REGISTER_DATA_STEP0'
export const RUN_ADD_REGISTER_DATA_STEP1		 			 = 		  		'RUN_ADD_REGISTER_DATA_STEP1'
export const RUN_ADD_REGISTER_DATA_STEP1_5		 			 = 		  		'RUN_ADD_REGISTER_DATA_STEP1_5'
export const RUN_ADD_REGISTER_DATA_STEP2					 = 		  		'RUN_ADD_REGISTER_DATA_STEP2'
export const RUN_ADD_REGISTER_DATA_STEP3					 = 		  		'RUN_ADD_REGISTER_DATA_STEP3'
export const RUN_ADD_REGISTER_DATA_STEP4		 			 = 		  		'RUN_ADD_REGISTER_DATA_STEP4'
export const RUN_GET_DIGILOCKER_URL		 			     	 = 		 		'RUN_GET_DIGILOCKER_URL'
export const RUN_GET_DIGILOCKER_KYC_DATA                     =              'RUN_GET_DIGILOCKER_KYC_DATA'
export const RUN_NO_ADD_NOMINEE								 = 		 		'RUN_NO_ADD_NOMINEE'

export const RUN_GET_INFORMATION				  			 = 		  		'RUN_GET_INFORMATION'
export const RUN_GET_REGISTER_STEP5				   			 = 		  		'RUN_GET_REGISTER_STEP5'
export const RUN_ADD_REGISTER_STEP5			     			 = 		  		'RUN_ADD_REGISTER_STEP5'
export const RUN_GENERATE_OTP_IPV			     			 = 		  		'RUN_GENERATE_OTP_IPV'
export const RUN_VERIFY_OTP_IPV			    	 			 = 		  		'RUN_VERIFY_OTP_IPV'
export const RUN_ADD_REGISTER_DATA_STEP_UPLOAD_DOCS			 = 		  		'RUN_ADD_REGISTER_DATA_STEP_UPLOAD_DOCS'
export const RUN_ADD_REGISTER_DATA_STEP_UPLOAD_VIA_CAM	     = 		  		'RUN_ADD_REGISTER_DATA_STEP_UPLOAD_VIA_CAM'
export const RUN_GET_INFORMATION_FROM_DIGILOCKER			 = 		  		'RUN_GET_INFORMATION_FROM_DIGILOCKER'
export const RUN_GET_STATUS_FROM_DIGILOCKER			         = 		  		'RUN_GET_STATUS_FROM_DIGILOCKER'



export const RUN_VERIFY_OTP 								 =        		'RUN_VERIFY_OTP'
export const RUN_SOCIAL_SIGNUP 								 =        		'RUN_SOCIAL_SIGNUP'
export const RUN_SOCIAL_LOGIN 								 =        		'RUN_SOCIAL_LOGIN' 
export const RUN_GET_QUESTION_ANSWER 						 =        		'RUN_GET_QUESTION_ANSWER'
export const RUN_SAVE_USER_QUESTION_ANS 					 = 		  		'RUN_SAVE_USER_QUESTION_ANS'
export const RUN_VERIFY_QUEST_ANS 							 = 		  		'RUN_VERIFY_QUEST_ANS'
export const RUN_USER_LOGIN_REAUTH 							 = 		  		'RUN_USER_LOGIN_REAUTH' 
export const RUN_CHANGE_PASSWORD 							 = 		  		'RUN_CHANGE_PASSWORD'
export const RUN_CHANGE_PASSWORD_FORGOT 					 = 		  		'RUN_CHANGE_PASSWORD_FORGOT'
export const RUN_CHANGE_FORGOT_PASSWORD 					 = 		  		'RUN_CHANGE_FORGOT_PASSWORD'
export const RUN_BLOCK_USER 								 = 		  		'RUN_BLOCK_USER'
export const RUN_UNBLOCK_USER 								 = 		  		'RUN_UNBLOCK_USER'
export const RUN_UNBLOCK_USER_HASH 							 = 		  		'RUN_UNBLOCK_USER_HASH'
export const RUN_STEP_SKIP_API 							     = 		  		'RUN_STEP_SKIP_API'
export const RUN_KRA_USER_KYC 							     = 		  		'RUN_KRA_USER_KYC'

export const RUN_DELETE_DOCUMENT 							 = 		  		'RUN_DELETE_DOCUMENT'

/* ************** getters ***********************/
export const GET_INFO 										 = 				'GET_INFO'
export const GET_TOKEN 										 = 				'GET_TOKEN'
export const GET_USER 										 = 				'GET_USER'
export const GET_LOADERS									 = 				'GET_LOADERS'
export const GET_USER_LIST 									 = 				'GET_USER_LIST'
export const GET_QUESTIONS 									 = 				'GET_QUESTIONS'
export const GET_BANK_AGGREGATOR_LIST 						 =              'GET_BANK_AGGREGATOR_LIST'
export const GET_IPV_RESPONSE                                =              'GET_IPV_RESPONSE'

/* ************** mutations - setters ***********************/
export const SET_INFO 										 = 				'SET_INFO'
export const SET_STATE 										 = 				'SET_STATE'
export const SET_STATE_PERSIST_LOCAL 						 = 				'SET_STATE_PERSIST_LOCAL'
export const SET_TOGGLE_LOADER 								 = 				'SET_TOGGLE_LOADER'
export const SET_STATE_USER_LIST 						     = 				"SET_STATE_USER_LIST"
export const SET_QUESTIONS 									 = 				"SET_QUESTIONS"
export const SET_BANK_AGGREGATOR_LIST						 = 				'SET_BANK_AGGREGATOR_LIST'
export const SET_IPV_RESPONSE                                =              'SET_IPV_RESPONSE'

// **********************DIGIO ESIGN*************************/
export const FETCH_DIGIO_ESIGN_ID                            =              'FETCH_DIGIO_ESIGN_ID';
export const RUN_SUBMIT_DIGIO_ESIGN_DOCUMENT                 =              'RUN_SUBMIT_ESIGN_DOCUMENT';


// ***********************Hyperverge***********************/
export const RUN_CREATE_HV_LEAD 	 						 = 		  		'RUN_CREATE_HV_LEAD'
export const RUN_CREATE_HV_DOCUMENT_EMAIL	 				 = 		  		'RUN_CREATE_HV_DOCUMENT_EMAIL'
export const RUN_RESEND_HV_OTP 	 							 = 		  		'RUN_RESEND_HV_OTP'
export const RUN_HV_OTP_VERIFY	 							 = 		  		'RUN_HV_OTP_VERIFY'






// WEBPACK FOOTER //
// ./src/types.js